<template>
  <view class="toast-text-only-demo">
    <cube-button  bindclick="clickToast">Toast - text only</cube-button>
    <cube-toast

      txt="纯文案"
      wx:ref="toast">
    </cube-toast>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    methods: {
      clickToast() {
        this.$refs.toast.show()
      }
    }
  })
</script>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-toast": "@mpxjs/mpx-cube-ui/src/components/toast/index"
    }
  }
</script>
